export const filterUndefined = <T>(items: Array<T | undefined>): Array<T> =>
  items.reduce<Array<T>>((prev, curr) => (curr == undefined ? prev : prev.concat(curr)), [])
